import React from 'react';
import { IAuditoriaProvisaoIssResultado } from '../interfaces/IAuditoriaProvisaoIss';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaProvisaoIssResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


const AuditoriaResumoProvisaoIss: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.provisoesAusentes?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Provisão Mensal de ISS</h3>
      <p className='text-muted'>
        Meses com faturamento de serviços sem lançamento localizado na conta redutora de ISS nem em ISS a Recolher
        no mesmo mês — indício que requer validação adicional (Lei Complementar nº 116/2003). Clique para ver a
        análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD Potencial</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_PROVISAO_ISS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Provisão Mensal de ISS sobre Serviços Prestados</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} competência{totalOcorrencias === 1 ? '' : 's'} com provisão ausente no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial (5% limitada a 1% da receita bruta), sujeita a validação — não é penalidade confirmada (Art. 12, II, Lei 8.218/91).</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoProvisaoIss;
